import { formatMoney } from 'common/src/other/currencyFormat';
import React, { useEffect, useState } from 'react';
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import { api } from 'common';
import { useTranslation } from "react-i18next";
import { Box, Tab, Tabs } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import dec from './../common/library';
import C2WithdrawsPanel from '../components/C2WithdrawsPanel';
import BonusAuditPanel from '../components/reports/BonusAuditPanel';
import { C2_FONT, c2PillTabsSx, c2TableTheme } from '../components/Table/C2UserTable';

const Withdraws = () => {
  const { t } = useTranslation();
  const settings = useSelector(state => state.settingsdata.settings);
  const {
    completeWithdrawRefer,
    rejectWithdrawRefer,
    getWithdrawUserContext,
    fetchWithdrawsRefer,
    stopFetchWithdrawsRefer
  } = api;
  const dispatch = useDispatch();
  const withdrawrefer = useSelector(state => state.withdrawrefer);
  const [tab, setTab] = useState('withdraws');

  useEffect(() => {
    dispatch(fetchWithdrawsRefer());
    return () => {
      dispatch(stopFetchWithdrawsRefer());
    };
  }, [dispatch, fetchWithdrawsRefer, stopFetchWithdrawsRefer]);

  const isLoading = withdrawrefer.loading && !withdrawrefer.withdraws;
  if (isLoading && tab === 'withdraws') return <CircularLoading />;

  return (
    <ThemeProvider theme={c2TableTheme}>
      <Box sx={{ width: '100%', fontFamily: C2_FONT }}>
        <Tabs
          value={tab}
          onChange={(e, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ ...c2PillTabsSx, mb: 2.5 }}
        >
          <Tab value="withdraws" label="Retiros de Comisión" />
          <Tab value="audit" label="Auditoría de Bonus" />
        </Tabs>

        {tab === 'withdraws' ? (
          <C2WithdrawsPanel
            rows={withdrawrefer.withdraws}
            settings={settings}
            title={t('Withdrawrefer_title')}
            subtitle={`El sistema valida cada solicitud y descuenta el saldo del bono de red. Transfiere el neto (monto menos el fee de plataforma del ${api.REFERRAL_WITHDRAW_FEE_PERCENT}%) solo a las validadas y márcalas como pagadas; si hay un problema, recházala y el saldo completo vuelve al conductor.`}
            emptyMessage={`Cuando un conductor solicite el retiro de su bono de red (días ${api.formatWithdrawPaydays()}), aparecerá aquí.`}
            csvFileName="retiros_comision.csv"
            processedCaption="Últimos 100 registros"
            formatAmount={(v) => formatMoney(dec(v || 0), settings, { isRTL: !!settings.swipe_symbol })}
            onMarkPaid={(row) => dispatch(completeWithdrawRefer(row))}
            onReject={(row, message) => dispatch(rejectWithdrawRefer(row, message))}
            getUserContext={getWithdrawUserContext}
            requireValidation
            showFee
            errorMsg={withdrawrefer.error && withdrawrefer.error.flag ? withdrawrefer.error.msg || 'Error al cargar los retiros de comisión.' : null}
          />
        ) : null}

        {tab === 'audit' ? <BonusAuditPanel /> : null}
      </Box>
    </ThemeProvider>
  );
}

export default Withdraws;
